<template>
  <div class="shop-details-wrap pt-100">
    <div class="container">
      <div class="row">
        <div class="col-xxl-10 offset-xxl-1">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="single-product-img bg-magnolia br-one round-10">
                <img
                  src="../../assets/img/shop/single-product-1.webp"
                  alt="Image"
                  class="d-block mx-auto"
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="single-product-details">
                <div class="single-product-title">
                  <div
                    class="product-price fs-26 fw-bold f-secondary text_secondary"
                  >
                    $532.00 <span class="discount fw-medium fs-24">$50.00</span>
                  </div>
                  <h1 class="section-title">Kitten Cake</h1>
                  <div class="ratings d-flex align-items-center">
                    <ul class="list-style">
                      <li>
                        <img
                          src="../../assets/img/icons/star-fill.svg"
                          alt="Image"
                        />
                      </li>
                      <li>
                        <img
                          src="../../assets/img/icons/star-fill.svg"
                          alt="Image"
                        />
                      </li>
                      <li>
                        <img
                          src="../../assets/img/icons/star-fill.svg"
                          alt="Image"
                        />
                      </li>
                      <li>
                        <img
                          src="../../assets/img/icons/star-fill.svg"
                          alt="Image"
                        />
                      </li>
                      <li>
                        <img
                          src="../../assets/img/icons/star-line.svg"
                          alt="Image"
                        />
                      </li>
                    </ul>
                    <span class="d-inline-block position-relative">
                      (02) Reviews
                    </span>
                  </div>
                  <p class="mb-0">
                    Truffaut sriracha health goth slow-carb taiyaki. Kogi beard
                    cred mukbang cornhole deep v, keffiyeh hoodie air plant
                    messenger bag. Tofu 90’s ethical, pabst tumblr waistcoat
                    brunch JOMO photo booth migas vape bicycle rights.
                  </p>
                </div>
                <div class="product-more-option">
                  <div class="product-action-item">
                    <div class="v-counter">
                      <button class="minusBtn" @click="decrement"></button>
                      <input
                        type="text"
                        size="25"
                        :value="quantity"
                        class="count"
                      />
                      <button class="plusBtn" @click="increment"></button>
                    </div>
                    <router-link to="/wishlist" class="add-to-wishlist round-6">
                      <i class="ri-heart-line"></i>
                    </router-link>
                  </div>
                  <div class="product-more-option-item">
                    <h5 class="fs-16 f-primary font-normal mb-0 text-para">
                      SKU :
                    </h5>
                    <span class="fw-medium text_secondary">254</span>
                  </div>
                  <div class="product-more-option-item">
                    <h5 class="fs-16 f-primary font-normal mb-0 text-para">
                      CATEGORY :
                    </h5>
                    <router-link
                      to="/shop-left-sidebar"
                      class="fw-medium text_secondary"
                    >
                      Foods
                    </router-link>
                  </div>
                  <div class="product-more-option-item">
                    <h5 class="fs-16 f-primary font-normal mb-0 text-para">
                      TAGS :
                    </h5>
                    <ul class="taglist list-style">
                      <li>
                        <router-link to="/shop-left-sidebar">Food</router-link>
                      </li>
                      ,
                      <li>
                        <router-link to="/shop-left-sidebar">
                          Popular
                        </router-link>
                      </li>
                      ,
                    </ul>
                  </div>
                  <div class="product-more-option-item">
                    <h5 class="fs-16 f-primary font-normal mb-0 text-para">
                      PRODUCT ID:
                    </h5>
                    <span class="fw-medium text_secondary">929H</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row pb-100">
            <div class="col-lg-12">
              <ul class="nav nav-tabs single-product-tablist" role="tablist">
                <li class="nav-item">
                  <button
                    class="nav-link active"
                    data-bs-toggle="tab"
                    data-bs-target="#tab_1"
                    type="button"
                    role="tab"
                  >
                    Description
                  </button>
                </li>
                <li class="nav-item">
                  <button
                    class="nav-link"
                    data-bs-toggle="tab"
                    data-bs-target="#tab_3"
                    type="button"
                    role="tab"
                  >
                    Reviews
                  </button>
                </li>
              </ul>
              <div class="tab-content product-tab-content">
                <div
                  class="tab-pane fade show active"
                  id="tab_1"
                  role="tabpanel"
                >
                  <div class="product_desc">
                    <div class="row">
                      <div class="col-xl-8 offset-xl-2">
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Vestibulum sagittis orci ac odio dictum
                          tincidunt. Donec ut metus leo. Class aptent taciti
                          sociosqu ad litora torquent per conubia nostra, per
                          inceptos. Sed is so luctus, dui eu sagittis sodales,
                          nulla nibh sagittis augue, vel porttitor diam enim non
                          metus.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="tab_3" role="tabpanel">
                  <div class="row">
                    <div class="col-xl-8 offset-xl-2">
                      <div
                        class="comment-box bg-magnolia br-one round-10 mb-45"
                      >
                        <h3 class="fs-34 mb-30">02 Comments</h3>
                        <div class="comment-item-wrap">
                          <div class="comment-item d-flex">
                            <div class="comment-author round-circle">
                              <img
                                src="../../assets/img/blog/avatar-1.webp"
                                alt="Image"
                                class="round-circle"
                              />
                            </div>
                            <div class="comment-info">
                              <div class="row align-items-center">
                                <div class="col-md-9">
                                  <h5>Amenda Smith</h5>
                                  <ul
                                    class="d-flex align-items-center list-style"
                                  >
                                    <li>
                                      <img
                                        src="../../assets/img/icons/star-fill.svg"
                                        alt="Image"
                                      />
                                    </li>
                                    <li>
                                      <img
                                        src="../../assets/img/icons/star-fill.svg"
                                        alt="Image"
                                      />
                                    </li>
                                    <li>
                                      <img
                                        src="../../assets/img/icons/star-fill.svg"
                                        alt="Image"
                                      />
                                    </li>
                                    <li>
                                      <img
                                        src="../../assets/img/icons/star-fill.svg"
                                        alt="Image"
                                      />
                                    </li>
                                    <li>
                                      <img
                                        src="../../assets/img/icons/star-line.svg"
                                        alt="Image"
                                      />
                                    </li>
                                  </ul>
                                </div>
                                <div class="col-md-12">
                                  <p>
                                    he design is simple and elegant. The
                                    customer support on this product is also
                                    amazing. I would highly recommend you to
                                    purchase templates from the Prag.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="comment-item d-flex">
                            <div class="comment-author round-circle">
                              <img
                                src="../../assets/img/blog/avatar-3.webp"
                                alt="Image"
                                class="round-circle"
                              />
                            </div>
                            <div class="comment-info">
                              <div class="row align-items-center">
                                <div class="col-md-9">
                                  <h5 class="fs-20">Tony Stark</h5>
                                  <ul
                                    class="d-flex align-items-center list-style"
                                  >
                                    <li>
                                      <img
                                        src="../../assets/img/icons/star-fill.svg"
                                        alt="Image"
                                      />
                                    </li>
                                    <li>
                                      <img
                                        src="../../assets/img/icons/star-fill.svg"
                                        alt="Image"
                                      />
                                    </li>
                                    <li>
                                      <img
                                        src="../../assets/img/icons/star-fill.svg"
                                        alt="Image"
                                      />
                                    </li>
                                    <li>
                                      <img
                                        src="../../assets/img/icons/star-fill.svg"
                                        alt="Image"
                                      />
                                    </li>
                                    <li>
                                      <img
                                        src="../../assets/img/icons/star-line.svg"
                                        alt="Image"
                                      />
                                    </li>
                                  </ul>
                                </div>
                                <div class="col-md-12">
                                  <p>
                                    he design is simple and elegant. The
                                    customer support on this product is also
                                    amazing. I would highly recommend you to
                                    purchase templates from the Prag.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="client-review-form">
                        <div class="comment-form-title">
                          <h4 class="text-black">Add A Review</h4>
                          <p>
                            Your email address will not be published. Required
                            fields are marked *
                          </p>
                        </div>
                        <div class="comment-form-title">
                          <h4>Your Ratings</h4>
                          <ul class="d-flex align-items-center list-style">
                            <li>
                              <img
                                src="../../assets/img/icons/star-fill.svg"
                                alt="Image"
                              />
                            </li>
                            <li>
                              <img
                                src="../../assets/img/icons/star-fill.svg"
                                alt="Image"
                              />
                            </li>
                            <li>
                              <img
                                src="../../assets/img/icons/star-fill.svg"
                                alt="Image"
                              />
                            </li>
                            <li>
                              <img
                                src="../../assets/img/icons/star-fill.svg"
                                alt="Image"
                              />
                            </li>
                            <li>
                              <img
                                src="../../assets/img/icons/star-line.svg"
                                alt="Image"
                              />
                            </li>
                          </ul>
                        </div>
                        <form action="#" class="comment-form mt-4">
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group mb-15">
                                <input
                                  type="text"
                                  name="name"
                                  id="name"
                                  class="br-one round-6 bg-transparent w-100 h-50"
                                  required
                                  placeholder="Name*"
                                />
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group mb-15">
                                <input
                                  type="email"
                                  name="email"
                                  id="email"
                                  class="br-one round-6 bg-transparent w-100 h-50"
                                  required
                                  placeholder="Email Address*"
                                />
                              </div>
                            </div>
                            <div class="col-lg-12">
                              <div class="form-group mb-15">
                                <textarea
                                  name="messages"
                                  id="messages"
                                  cols="30"
                                  rows="6"
                                  class="br-one round-10 bg-transparent w-100 h-180 resize-0"
                                  placeholder="Please Enter Your Comment Here"
                                ></textarea>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-check checkbox">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id="test_2"
                                />
                                <label class="form-check-label" for="test_2">
                                  Save my name, email, and website in this
                                  browser for the next time I comment.
                                </label>
                              </div>
                            </div>
                            <div class="col-md-12 mt-3">
                              <button class="btn style-one d-block w-100">
                                Post A Review
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "ProductDetails",
  setup() {
    const quantity = ref(1);

    const increment = () => {
      quantity.value++;
    };

    const decrement = () => {
      if (quantity.value > 1) {
        quantity.value--;
      }
    };

    return {
      quantity,
      increment,
      decrement,
    };
  },
});
</script>